<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <h4>Client Reports</h4>
                    <ReportDownloader report-label="Child Birthdays"
                                      endpoint="Core/Reports/ProgramReports/GetBirthdays"
                                      :parameter-schema="ParamsClientBirthdayOptions"
                                      report-description="Lists the birthdays of current children, with options to specify the level of privacy on the generated list." />
                    <ReportDownloader report-label="Occupancy Report"
                                      endpoint="Core/Reports/ProgramReports/SubProgramOccupancyReport"
                                      permission-requirement="ReportsModuleAccess"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Generates an Occupancy report for the specified time period.  Weekly reporting should be Thursday to Wednesday." />
                    <ReportDownloader report-label="Client Roster"
                                      endpoint="Core/Reports/ProgramReports/GlobalClientRoster"
                                      permission-requirement="GlobalClientRoster"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Generates a list of all clients enrolled during the time period specified" />

                </div>
                <div class="col-md-4">
                    <h4>Mental Health Reports</h4>
                    <ReportDownloader report-label="My Productivity Data"
                                      endpoint="MentalHealth/Billing/Reports/GetProviderHoursAndOnTime"
                                      :parameter-schema="ParamsMyProductivity"
                                      report-description="Provides a list of Welligent notes that you have completed, with their completion date, due date, and whether or not the note was written on time.  Summary report split by assigned supervisor.  NOTE:  Anything done in Welligent takes up to 2 hours to appear here in OLIVER." />
                    <ReportDownloader permission-requirement="MentalHealth.Employees.Productivity"
                                      report-label="Provider MH Productivity"
                                      endpoint="MentalHealth/Billing/Reports/GetProviderHoursAndOnTime"
                                      :parameter-schema="ParamsStartEndLocationResidential"
                                      report-description="Provides a list of notes for each provider, with their completion date, due date, and whether or not the note was written on time.  Summary report split by assigned supervisor" />

                    <ReportDownloader permission-requirement="MentalHealth.Employees.Productivity"
                                      report-label="Last MH Services"
                                      endpoint="MentalHealth/Billing/Reports/LastMHServicesReport"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Lists all clients enrolled in the target time period and indicates the last documented mental health service as well as the last documented 530 ICCR." />

                </div>
                <div class="col-md-4">
                    <h4>Misc Reports</h4>

                    <ReportDownloader report-label="Discharge Outcomes By Employee"
                                      permission-requirement="Administrator"
                                      endpoint="Core/Reports/ProgramReports/DischargeOutcomesByEmployee"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Provides a list that shows average length of stay by Caseload Assignment" />


                </div>
                <div class="col-md-4">
                    <h4>Financial Reports</h4>
                    <ReportDownloader report-label="Census Verification"
                                      report-description="Downloads a list of activity for the period indicated.  An identical report can be emailed to the program's distribution list for approval/rejection."
                                      endpoint="Core/CensusApprovals/CreateCensusApproval"
                                      :parameter-schema="ParamsSubProgramStartEndReportType" />
                    <ReportDownloader report-label="Census Financials"
                                      report-description="Generates Revenue/Expense transactions for all billable activity in the specified month and year."
                                      endpoint="Core/CensusApprovals/TransactionsReport"
                                      permission-requirement="Reports.CensusFinancials"
                                      :parameter-schema="ParamsSubProgramMonthYear" />


                </div>

            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ReportDownloader from '../../Core/UI/ReportDownloader.vue';
    export default {
        props: [],
        data: function () {
            return {
                ParamsClientBirthdayOptions: [
                    {
                        Label: "Program:",
                        Name: "SubProgramId",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Columns to Show:",
                        Type: "CheckBoxBool",
                        Required: false,
                        Options: [
                            {
                                text: "Include Last Name",
                                name: "IncludeLastName",
                                checked: true
                            },
                            {
                                text: "Include Date Of Birth",
                                name: "IncludeDateOfBirth",
                                checked: true
                            },
                            {
                                text: "Include Year Of Birth",
                                name: "IncludeYearOfBirth",
                                checked: true
                            },
                            {
                                text: "Include Month",
                                name: "IncludeDayOfMonth",
                                checked: true
                            },
                            {
                                text: "Include Day",
                                name: "IncludeDay",
                                checked: true
                            },
                            {
                                text: "Include Age",
                                name: "IncludeAge",
                                checked: true
                            },
                            {
                                text: "Include Gender",
                                name: "IncludeGender",
                                checked: true
                            }
                        ]
                    }
                ],
                ParamsMyProductivity: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Location:",
                        Name: "Location",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Employee:",
                        Name: "MyAppointmentsOnly",
                        Type: "HiddenConstant",
                        Value: true,
                        DisplayValue: "Me"
                    },
                ],
                ParamsStartEndLocationResidential: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Location:",
                        Name: "Location",
                        Type: "Select",
                        Required: true,
                        Options: []
                    }
                    //{
                    //    Label: "Location:",
                    //    Name: "Location",
                    //    Type: "HiddenConstant",
                    //    Value: "Residential",
                    //    DisplayValue: "Residential"
                    //}
                ],
                ParamsSubProgramStartEnd: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsSubProgramMonthYear: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Month (1-12):",
                        Name: "Month",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Year (4 digits):",
                        Name: "Year",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Report Type:",
                        Name: "ReportType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "View Report Only",
                                value: "Download Only"
                            },
                            {
                                text: "Generate New Approval Email",
                                value: "Generate Approval Email"
                            },
                        ]
                    },
                ],
                ParamsSubProgramStartEndReportType: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Report Type:",
                        Name: "ReportType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "View Report Only",
                                value: "Download Only"
                            },
                            {
                                text: "Generate New Approval Email",
                                value: "Generate Approval Email"
                            },
                        ]
                    },
                ],
            };
        },
        methods: {

        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
        },
        components: {
            ReportDownloader
        },
        mounted() {
            let vm = this;
            this.ParamsClientBirthdayOptions[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramStartEnd[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramMonthYear[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramStartEndReportType[0].Options = this.SubProgramOptions;

            //location selection
            this.ParamsStartEndLocationResidential[2].Options = [];
            vm.SubProgramOptions.forEach(function (spo) {
                if (spo.text == "Inland STRTP") {
                    vm.ParamsStartEndLocationResidential[2].Options.push({
                        text: "Inland STRTP",
                        value: "Residential"
                    });
                    vm.ParamsMyProductivity[2].Options.push({
                        text: "Inland STRTP",
                        value: "Residential"
                    });
                }
                if (spo.text == "Desert Outpatient") {
                    vm.ParamsStartEndLocationResidential[2].Options.push({
                        text: "Desert Outpatient",
                        value: "Outpatient"
                    });
                    vm.ParamsMyProductivity[2].Options.push({
                        text: "Desert Outpatient",
                        value: "Outpatient"
                    });
                }
            });
        }
    }
</script>

<style scoped>
</style>